export default __webpack_public_path__ + "static/media/articalOne.09b429f7.png";